<div>

  <div class="w3-large" style="float: right;">
    <a (click)="close()">
      <mat-icon>close</mat-icon>
    </a>
  </div>
  <table class="table table-striped tablefixed">
    <thead>
      <tr>
        <th> {{'PURCHASE_ORDER_MODULE.SHOW_PARTIAL_DELIVERIES_COMPONENT.TABLE_HEADERS.RECEIVED_QUANTITY' | translate}}
        </th>
        <th> {{'PURCHASE_ORDER_MODULE.SHOW_PARTIAL_DELIVERIES_COMPONENT.TABLE_HEADERS.UNIT' | translate}}
        </th>
        <th> {{'PURCHASE_ORDER_MODULE.SHOW_PARTIAL_DELIVERIES_COMPONENT.TABLE_HEADERS.BATCH_LOT_NUMBER' | translate}}
        </th>
        <th> {{'PURCHASE_ORDER_MODULE.SHOW_PARTIAL_DELIVERIES_COMPONENT.TABLE_HEADERS.CREATED_ON' | translate}}
        </th>
        <th> {{'PURCHASE_ORDER_MODULE.SHOW_PARTIAL_DELIVERIES_COMPONENT.TABLE_HEADERS.MANUFACTURING_DATE' | translate}}
        </th>
        <th> {{'PURCHASE_ORDER_MODULE.SHOW_PARTIAL_DELIVERIES_COMPONENT.TABLE_HEADERS.EXPIRY_DATE' | translate}} </th>
      </tr>
    </thead>
    <tbody>

      <tr *ngFor="let pd of deliveries.poItemDeliveryDtos">
        <td>{{pd.receivedQuantity}}</td>
        <td>
          <span *ngIf="pd.unit==pOUnitEnum.KG">{{'PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.KG' | translate }} </span>
          <span *ngIf="pd.unit==pOUnitEnum.TONNE">{{'PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.TONNE' | translate }}
          </span>

        </td>
        <td>{{pd.batchNumber}}</td>

        <td>{{pd.createdOn|date:'mediumDate'}}</td>
        <td>{{pd.manufactureDate|date:'mediumDate'}}</td>
        <td>{{pd.expiryDate|date:'mediumDate'}}</td>
      </tr>

    </tbody>
  </table>

  <div class="p-8" style="text-align: right;">

    <button class="btn btn-default" (click)="dialogRef.close(true)">
      {{'PURCHASE_ORDER_MODULE.SHOW_PARTIAL_DELIVERIES_COMPONENT.BUTTON' | translate}}
    </button>


  </div>
</div>